export default {"src":"/_next/static/media/cricket.2a746e98.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};